(() => {
    function initSlider() {
      const swiperOptions = {
        loop: false,
        slidesPerView: 1.33,
        spaceBetween: 24,
      };
      const swiperElement = document.querySelector('.holiday--sets-slider-wrapper .swiper');
      if (!swiperElement || swiperElement.dataset.isLoaded == 'true') return;
      const swiper = new Swiper(swiperElement, swiperOptions);
      swiper.on('slideChange', function () {
        const currentIndex = this.activeIndex + 1;
        handleHPcaronav(currentIndex);
      });
      swiperElement.setAttribute('data-is-loaded', true);
    }
  
    function handleHPcaronav(index) {
      const wrapper = document.querySelector('.holiday--sets-slider-wrapper');
      const slider = wrapper.querySelector('.holiday--sets-slider-wrapper .swiper');
      const total_slides = wrapper.querySelectorAll('.swiper-slide').length;
      const current_index = parseInt(slider.dataset.currentIndex);
      let next_index = null;
      if (index === 'next') {
        next_index = current_index + 1;
        const nextSlide = wrapper.querySelector(`.swiper-slide[data-slider-index="${next_index}"]`);
        if (!nextSlide) return;
        slider.setAttribute('data-current-index', next_index);
      } else if (index == 'prev') {
        next_index = current_index - 1;
        const prevSlide = wrapper.querySelector(`.swiper-slide[data-slider-index="${next_index}"]`);
        if (prevSlide) {
          slider.setAttribute('data-current-index', next_index);
        }
      } else {
        next_index = index;
        const slide = wrapper.querySelector(`.swiper-slide[data-slider-index="${index}"]`);
        if (slide) {
          slider.setAttribute('data-current-index', index);
        }
      }
      // update the navigation buttons
      const prevButton = wrapper.querySelector('.drawer__slider-controls .navigation_arrows .--arrow_prev');
      const nextButton = wrapper.querySelector('.drawer__slider-controls .navigation_arrows .--arrow_next');
      if (next_index == 1) {
        prevButton.setAttribute('disabled', 'disabled');
      } else {
        prevButton.removeAttribute('disabled');
      }
      if (next_index == total_slides) {
        nextButton.setAttribute('disabled', 'disabled');
      } else {
        nextButton.removeAttribute('disabled');
      }
  
      // update dots
      const dots = wrapper.querySelectorAll('.control__dot');
      dots.forEach((dot) => {
        const dotIndex = parseInt(dot.dataset.dotIndex);
        if (dotIndex == next_index) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
  
      // upadte pagination
      const currentPage = wrapper.querySelector('.current_page');
      currentPage.textContent = next_index;
  
      const swiper = slider.swiper;
      if (swiper) {
        if (index === 'next') {
          swiper.slideNext();
        } else if (index === 'prev') {
          swiper.slidePrev();
        } else {
          swiper.slideTo(index - 1);
        }
      }
    }
    window.handleHPcaronav = handleHPcaronav;
    initSlider();
  })();
  